import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-ordem-servico',
  templateUrl: './modal-ordem-servico.component.html',
  styleUrls: ['./modal-ordem-servico.component.css']
})
export class ModalOrdemServicoComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialogRef: MatDialogRef<ModalOrdemServicoComponent>) { }

  ngOnInit() {
  }

  
  RetornarLucro() {
    return this.data.orcamento.servicos.reduce((x: any, y: any) => x + Number(y.valorresultadomensal), 0) + this.data.orcamento.produtos.reduce((x: any, y: any) => x + Number(y.valorresultadomensal), 0)
  }
}
